import { useRouteContext } from "./shared/route-context";

export function useHealthcheck() {
	const { healthcheck } = useRouteContext();
	return healthcheck;
}
